import { AutogenModelExchangeControl, AutogenRowExchangeControl } from "./autogen/AutogenModelExchangeControl";

export class ModelExchangeControl extends AutogenModelExchangeControl<RowExchangeControl> {
	constructor() {
		super(RowExchangeControl);
	}
}

export class RowExchangeControl extends AutogenRowExchangeControl {
}